import * as React from 'react';

import { Table } from 'reactstrap';

import RecapReportTests from '../RecapReportTests';

import { IDrillString, IPump, ISolidsControl } from '../../../../../Interfaces/TestInterface';

class IInterval {
    public casingID: number = 0;
    public casingTop: number = 0;
    public depthMD: number = 0;
    public drillString: IDrillString[] = [];
    public fluidType: string = '';
    public intervalType: string = '';
    public pumps: IPump[] = [];
    public solids: ISolidsControl[] = [];
    public subInt: string = '';
    public topFt: number = 0;
    public wellTests: any[] = [];
}

class RecapReportIntervals extends React.Component {
    public props: any;
    private recap: any;

    public state = {
        recap: this.recap
    };

    constructor(props: any) {
        super(props);

        this.renderBlanks = this.renderBlanks.bind(this);
        this.returnDrillStringLength = this.returnDrillStringLength.bind(this);
        this.returnSolidsLength = this.returnSolidsLength.bind(this);
        this.returnPumpsLength = this.returnPumpsLength.bind(this);
    }

    public componentWillReceiveProps(nextProps: any) {
        if (nextProps !== this.props) {
            this.setState({
                recap: nextProps.recap
            });
        }
    }

    private renderBlanks(interval: IInterval, difference: number, columns: number) {
        let highest = Math.max(this.returnSolidsLength(interval), this.returnDrillStringLength(interval), this.returnPumpsLength(interval));
        if (highest <= 0) {
            highest = 1;
        }
        return (
            Array.apply(null, Array(highest - difference)).map((index: number) =>
                <tr key={index}>
                {Array.apply(null, Array(columns)).map((position: number) =>
                    <td key={position}/>
                )}
                </tr>
            )
        );
    }

    private renderSolids(solidsControlItems: any) {
        const listOne: string[] = [];
        const listTwo: string[] = [];
        if (solidsControlItems != null) {
            solidsControlItems.map((item: any, index: number) => {
                if (index % 2 === 0) {
                    listOne.push(item.makeModel);
                } else {
                    listTwo.push(item.makeModel);
                }
            });
            return (
                listOne.map((item: string, index: number) =>
                    <tr key={index}>
                        <td>{item}</td>
                        <td>{listTwo[index]}</td>
                    </tr>
                )
            );
        }
        return true;
    }

    private returnDrillStringLength(interval: IInterval) {
        if (interval.drillString && interval.drillString !== null) {
            return interval.drillString.length;
        }
        return 0;
    }
    private returnSolidsLength(interval: IInterval) {
        if (interval.solids && interval.solids !== null) {
            return interval.solids.length;
        }
        return 0;
    }
    private returnPumpsLength(interval: IInterval) {
        if (interval.pumps && interval.pumps !== null) {
            return interval.pumps.length;
        }
        return 0;
    }

    public render() {
        return(
            <div className="RecapReportIntervals">
                { this.state.recap && this.state.recap.intervals.length > 0 &&
                    this.state.recap.intervals.map((interval: any, index: number) =>
                    <div key={index} className="IntervalGroup">
                        <h5>{'Interval: ' + interval.intervalType}</h5>
                        <h5>{'Sub Interval: ' + interval.subInt}</h5>
                        <Table className="Main">
                            <tbody>
                                <tr>
                                    <td>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className="label" colSpan={3}>Interval / Casing Record</td>
                                                </tr>
                                                <tr>
                                                    <td className="label">Size</td>
                                                    <td className="label">Top @</td>
                                                    <td className="label">Set @</td>
                                                </tr>
                                                <tr>
                                                    <td>{interval.casingID}</td>
                                                    <td>{interval.topFt}</td>
                                                    <td>{interval.casingTop}</td>
                                                </tr>
                                                {this.renderBlanks(interval, 1, 3)}
                                            </tbody>
                                        </Table>
                                    </td>
                                    <td>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className="label" colSpan={3}>Drill Assembly</td>
                                                </tr>
                                                <tr>
                                                    <td className="label">Item</td>
                                                    <td className="label">Size</td>
                                                    <td className="label">Length</td>
                                                </tr>
                                                {interval.drillString &&
                                                    interval.drillString.map((item: any, position: number) =>
                                                        <tr key={position}>
                                                            <td>{item.itemType}</td>
                                                            <td>{item.innerDiameter}</td>
                                                            <td>{item.length}</td>
                                                        </tr>
                                                    )
                                                }
                                                {this.renderBlanks(interval, this.returnDrillStringLength(interval), 3)}
                                            </tbody>
                                        </Table>
                                    </td>
                                    <td>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className="label" colSpan={2}>Mud System</td>
                                                </tr>
                                                <tr>
                                                    <td className="label">Fluid Type</td>
                                                    <td className="label">Depth</td>
                                                </tr>
                                                <tr>
                                                    <td>{interval.fluidType}</td>
                                                    <td>{interval.depthMD}</td>
                                                </tr>
                                                {this.renderBlanks(interval, 1, 2)}
                                            </tbody>
                                        </Table>
                                    </td>
                                    <td>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className="label" colSpan={2}>Solids Control Equipment</td>
                                                </tr>
                                                <tr>
                                                    <td className="label">Brand / Type</td>
                                                    <td className="label">Brand / Type</td>
                                                </tr>
                                                {interval.solids &&
                                                    this.renderSolids(interval.solids)
                                                }
                                                {this.renderBlanks(interval, Math.ceil(this.returnSolidsLength(interval)/2), 2)}
                                            </tbody>
                                        </Table>
                                    </td>
                                    <td>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td className="label" colSpan={4}>Pump Specifications</td>
                                                </tr>
                                                <tr>
                                                    <td className="label">No.</td>
                                                    <td className="label">Type</td>
                                                    <td className="label">Size</td>
                                                    <td className="label">EFF</td>
                                                </tr>
                                                {interval.pumps &&
                                                    interval.pumps.map((pump: any, no: number) =>
                                                        <tr key={no}>
                                                            <td>{no + 1}</td>
                                                            <td>{pump.make + '/' + pump.model}</td>
                                                            <td>{pump.linerSize}</td>
                                                            <td>{pump.efficiency}</td>
                                                        </tr>
                                                    )
                                                }
                                                {this.renderBlanks(interval, this.returnPumpsLength(interval), 4)}
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        {interval.wellTests && interval.wellTests !== null && interval.wellTests.length > 0 &&
                            <RecapReportTests wellTests={interval.wellTests}/>
                        }
                    </div>
                ) }
            </div>
        );
    }
}

export default RecapReportIntervals;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportIntervals/RecapReportIntervals.tsx